module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/report_dummy_01-30e00ef2092ac48919d13f2506f62c82.jpg";